import { ModalBlocker, ModalHeader, ModalWindow, Panel } from '@epam/promo';
import { ModalWrapperProps } from './ModalWrapper.model';
import css from '../BaseModal/BaseModal.module.scss';

export const ModalWrapper = <TData,>({
  children,
  context,
  data,
  width = '600',
}: ModalWrapperProps<TData>) => {
  const { abort, isActive, key, zIndex } = context;

  return (
    <ModalBlocker
      key={key}
      abort={abort}
      isActive={isActive}
      rawProps={{ 'data-testid': 'modal-window' }}
      success={abort}
      zIndex={zIndex}>
      <ModalWindow height="700" width={width}>
        <Panel background="white">
          <ModalHeader
            cx={css.modal__header}
            title={data.title}
            onClose={abort}
          />
          {children}
        </Panel>
      </ModalWindow>
    </ModalBlocker>
  );
};
